import { ManagersTableActionTypes, ManagersTableActions } from '@appStore/managers/actions/managers-table.actions';
import { TableState } from '@model';

export interface State {
  usersTable: TableState;
  invitationsTable: TableState;
  customerUsersTable: TableState;
  customersTable: TableState;
  userCustomersTable: TableState;
}

export const initialState: State = {
  usersTable: TableState.initialState('name'),
  invitationsTable: TableState.initialState('email'),
  customerUsersTable: TableState.initialState('name'),
  customersTable: TableState.initialState('customerName'),
  userCustomersTable: TableState.initialState('customerName')
};

export function reducer(state = initialState, action: ManagersTableActions): State {
  switch (action.type) {
    case ManagersTableActionTypes.ManagerUsersPageChange:
      return { ...state, usersTable: action.payload };
    case ManagersTableActionTypes.ManagerInvitationsPageChange:
      return { ...state, invitationsTable: action.payload };
    case ManagersTableActionTypes.ManagerCustomerUsersPageChange:
      return { ...state, customerUsersTable: action.payload };
    case ManagersTableActionTypes.ManagerCustomersPageChange:
      return { ...state, customersTable: action.payload };
    case ManagersTableActionTypes.ManagerUserCustomersPageChange:
      return { ...state, userCustomersTable: action.payload };
    case ManagersTableActionTypes.ManagersTableStateReset:
      return initialState;
  }

  return state;
}

export const getManagerUsersTableState = (state: State) => state.usersTable;
export const getManagerInvitationsTableState = (state: State) => state.invitationsTable;
export const getManagerCustomerUsersTableState = (state: State) => state.customerUsersTable;
export const getManagerCustomersTableState = (state: State) => state.customersTable;
export const getManagerUserCustomersTableState = (state: State) => state.userCustomersTable;
